<script lang="ts">
	import { Icon } from '@repo/commons/components'
	import { SessionDescriptionModalityEnum } from '@semanticedge/sessionviewer-service-noheaders-client/src/models/SessionDescription'
	import type { SidebarSession } from '@repo/commons/models'
	import { format } from 'date-fns'

	interface Props extends SidebarSession {
		isActive?: boolean
		onClick?: () => void
		onDelete?: () => void
		startTime?: string | Date
		modality?: SessionDescriptionModalityEnum
	}

	let { startTime, modality, isActive = false, onClick, onDelete }: Props = $props()

	const timestamp = $derived.by(() =>
		startTime ? format(new Date(startTime), 'dd/MM/yyyy HH:mm:ss') : ''
	)

	const handleClick = () => {
		onClick?.()
	}

	const handleDelete = (e: Event) => {
		e.stopPropagation()
		onDelete?.()
	}
</script>

<div
	class="session-item group"
	class:active={isActive}
	onclick={handleClick}
	role="button"
	aria-pressed={isActive}
	aria-current={isActive}
	tabindex="0"
	onkeydown={(e) => e.key === 'Enter' && handleClick()}
>
	<div class="icon-wrapper">
		{#if modality === SessionDescriptionModalityEnum.Chat}
			<Icon name="chat" size="sm" class="text-[#002C4D80]" />
		{:else if modality === SessionDescriptionModalityEnum.Voice}
			<Icon name="phone" size="sm" class="text-[#002C4D80]" />
		{/if}
	</div>

	<div class="timestamp-wrapper">
		<p class="timestamp-text">{timestamp}</p>
	</div>

	{#if onDelete}
		<button class="delete-button" onclick={handleDelete} aria-label="Delete session">
			<Icon name="trash" size="sm" class="text-[#002C4D80]" />
		</button>
	{/if}
</div>

<style lang="postcss">
	.session-item {
		@apply relative flex items-center gap-2.5 px-4 py-2 rounded-lg cursor-pointer transition-all duration-200 hover:bg-[#0049800D];
	}

	.session-item.active {
		@apply bg-[#007ACC1A] font-bold;
	}

	.session-item.active .timestamp-text {
		@apply font-bold;
	}

	.icon-wrapper {
		@apply relative flex-shrink-0 text-[#002C4D80];
	}

	.timestamp-wrapper {
		@apply flex-1 min-w-0;
	}

	.timestamp-text {
		@apply text-gray-900 font-normal text-base truncate;
	}

	.delete-button {
		@apply flex-shrink-0 rounded-md p-1 transition-opacity duration-200 opacity-0 hover:bg-gray-200;
		width: 24px;
		height: 24px;
	}

	.session-item:hover .delete-button {
		@apply opacity-100;
	}
</style>
